import React from "react";
import { ArrowRight, Search, MapPin } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";

const Hero = () => {
  const { t } = useLanguage();

  const scrollTo = (id) => (e) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      className="relative overflow-hidden"
      data-testid="hero-section"
    >
      {/* Soft background gradient */}
      <div className="absolute inset-0 -z-10">
        <div
          className="absolute inset-0"
          style={{
            background:
              "radial-gradient(1200px 600px at 10% 0%, #E6EDE7 0%, transparent 60%), radial-gradient(900px 500px at 90% 20%, #F5EEE7 0%, transparent 60%), #FAFAF9",
          }}
        />
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-20 pb-24 lg:pt-28 lg:pb-32 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-7 anim-fade-in-up">
          <div className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] font-bold text-[#5C6B5D] mb-6">
            <MapPin className="w-3.5 h-3.5" strokeWidth={1.75} />
            {t.hero.eyebrow}
          </div>
          <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-[1.05] text-[#202C21] font-semibold">
            {t.hero.title_1}{" "}
            <span className="relative inline-block">
              <span className="relative z-10 text-[#5F7C63]">
                {t.hero.title_2}
              </span>
              <span
                aria-hidden="true"
                className="absolute left-0 right-0 bottom-1 h-3 bg-[#DDE5DD] -z-0 rounded"
              />
            </span>{" "}
            {t.hero.title_3}
          </h1>
          <p className="mt-6 text-base sm:text-lg text-[#5C6B5D] leading-relaxed max-w-2xl">
            {t.hero.subtitle}
          </p>

          {/*<form
            onSubmit={(e) => e.preventDefault()}
            className="mt-10 flex items-center gap-2 bg-white shadow-[0_12px_48px_rgba(32,44,33,0.08)] rounded-full p-2 pl-5 max-w-xl border border-[rgba(117,148,122,0.12)]"
            data-testid="hero-search-form"
          >
            <Search className="w-5 h-5 text-[#8A9A8B]" strokeWidth={1.75} />
            <input
              type="text"
              placeholder={t.hero.placeholder}
              className="flex-1 bg-transparent outline-none text-base font-body text-[#202C21] placeholder:text-[#8A9A8B] py-3"
              data-testid="hero-search-input"
            />
            <a
              href="#freelancers"
              onClick={scrollTo("freelancers")}
              className="bg-[#75947A] text-white hover:bg-[#5F7C63] rounded-full px-5 py-3 text-sm font-medium transition-colors whitespace-nowrap"
              data-testid="hero-search-submit"
            >
              {t.hero.view}
            </a>
          </form>*/}

          <div className="mt-6 flex flex-wrap items-center gap-3">
            <a
              href="#freelancers"
              onClick={scrollTo("freelancers")}
              className="inline-flex items-center gap-2 text-[#202C21] hover:text-[#5F7C63] font-medium transition-colors"
              data-testid="hero-view-freelancers"
            >
              {t.hero.view}
              <ArrowRight className="w-4 h-4" strokeWidth={1.75} />
            </a>
            <span className="text-[#8A9A8B]">·</span>
            <a
              href="#project-form"
              onClick={scrollTo("project-form")}
              className="inline-flex items-center gap-2 text-[#202C21] hover:text-[#5F7C63] font-medium transition-colors"
              data-testid="hero-describe-project"
            >
              {t.hero.describe}
              <ArrowRight className="w-4 h-4" strokeWidth={1.75} />
            </a>
          </div>
        </div>

        <div className="lg:col-span-5 hidden lg:block anim-fade-in-up delay-150">
          <div className="relative aspect-[4/5] rounded-[32px] overflow-hidden bg-[#E6EDE7] border border-[rgba(117,148,122,0.2)] shadow-[0_24px_80px_rgba(32,44,33,0.08)]">
            <img
              src="/images/ericeira-praia-dos-pescadores.webp"
              alt="Ericeira coastline"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#202C21]/30 via-transparent to-transparent" />
            <div className="absolute bottom-6 left-6 right-6 bg-white/90 backdrop-blur-md rounded-2xl p-4 border border-white/60">
              <p className="text-xs uppercase tracking-[0.2em] font-bold text-[#5C6B5D]">
                Ericeira · PT
              </p>
              <p className="font-heading text-lg font-semibold text-[#202C21] mt-1">
                Freelancers Network
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
